<template>
  <div class="visitor-detail">
    <a-descriptions v-viewer bordered>
      <a-descriptions-item label="访客姓名">{{info.visitor_name}}</a-descriptions-item>
      <a-descriptions-item label="访客事由">{{info.visit_purpose}}</a-descriptions-item>
      <a-descriptions-item label="访客人数">{{info.visitor_number}}</a-descriptions-item>
      <a-descriptions-item label="车牌号">{{info.licence}}</a-descriptions-item>
      <a-descriptions-item label="受访住户">{{info.resident_name}}</a-descriptions-item>
      <a-descriptions-item label="受访房屋">{{info.resident_address}}</a-descriptions-item>
      <a-descriptions-item label="有效截止时间">{{info.visit_time.split(' ')[0]}}</a-descriptions-item>
      <a-descriptions-item label="申请时间">{{info.created_at}}</a-descriptions-item>
      <a-descriptions-item label="状态">{{visitorStatusText(info.is_visit)}}</a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
  import VisitorService from '@/io/visitor.js';
  import {
    visitorStatusText
  } from '@/io/dict.js';

  export default {
    name: 'VisitorDetail',
    props: {
      id: {
        type: Number,
        default: null
      },
    },
    data() {
      let self = this;
      return {
        visitorStatusText,
        info: {
          visit_time: ''
        },
      }
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          if (newValue) {
            this.initInfo();
          }
        },
        immediate: true
      }
    },
    methods: {
      initInfo() {
        return VisitorService.info(this.id).then(res => {
          this.info = res;
        }).catch(err => {});
      },
    },
  }
</script>

<style lang="less" scoped>
  
</style>